const backendUrl = "http://vue.bkx:5000"

export default {
  backendUrl
}